export default "__VITE_ASSET__1j4RtYZk__"